import React from 'react'

const CancelOrder = () => {
  return (
    <div>CancelOrder</div>
  )
}

export default CancelOrder